import { Entity, Field } from "typegraph";

import Entry from "./Entry";

@Entity({one: "programTrackProduct", many: "programTrackProducts"})
export default class ProgramTrackProduct {

	@Field()
	public id: string;

	@Field({entity: Entry})
	public entry: Entry;

}



// WEBPACK FOOTER //
// ./src/panels/tracksProgram/entities/ProgramTrackProduct.ts